import { Theme, useMediaQuery } from '@mui/material';

export function useIsMobileViewport() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
}
